// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2HIyd","expandIcon":"AccordionButton_expandIcon__3cXvc","expanded":"AccordionButton_expanded__1r53y"};